<div class="modal" id="driversSalaryPaymentsQuestion" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno usunąć?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="deleteConfirm()">Tak</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="deleteDialogClose()">
					Nie
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal" id="driversSalaryPaymentsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<table class="table table-striped table-hover">
					<thead class="table-dark">
						<tr>
							<th class="align-middle">Data wypłaty</th>
							<th class="align-middle">Wartość</th>
							<th class="align-middle">Forma wypłaty</th>
							<th class="align-middle">Waluta</th>
							<th class="align-middle">Uwagi</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of paymentsData">
							<td class="text-end align-midle">
								<input
									type="date"
									class="form-control"
									name="comment"
									[(ngModel)]="item.date"
									[disabled]="!item.editable"
								/>
							</td>
							<td class="text-end align-midle">
								<input
									type="number"
									step="0.01"
									class="form-control"
									name="value"
									[(ngModel)]="item.value"
									[disabled]="!item.editable"
								/>
							</td>
							<td class="text-end align-midle">
								<select
									type="text"
									class="form-select"
									name="type"
									[(ngModel)]="item.paymentMethod"
									[disabled]="!item.editable"
								>
									<option value="" disabled></option>
									<option [value]="item.id" *ngFor="let item of paymentMethod">
										{{ item.name }}
									</option>
								</select>
							</td>
							<td class="text-end align-midle">
								<select
									type="text"
									class="form-select"
									name="currency"
									[(ngModel)]="item.currency"
									[disabled]="!item.editable"
								>
									<option value="PLN">PLN</option>
									<option value="EUR">EUR</option>
								</select>
							</td>
							<td class="text-end align-midle">
								<input
									type="text"
									class="form-control"
									name="comment"
									[(ngModel)]="item.comment"
									[disabled]="!item.editable"
								/>
							</td>
							<td class="text-end align-middle">
								<div class="btn btn-primary" *ngIf="!item.editable" (click)="item.editable = true">
									Edytuj
								</div>
								<div class="btn btn-danger me-1" *ngIf="item.editable" (click)="save(item)">Zapisz</div>
								<div class="btn btn-primary" *ngIf="item.editable" (click)="deleteAsk(item)">Usuń</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="d-grid gap-2">
					<div class="btn btn-primary" (click)="addPos()"><i class="fas fa-plus"></i> Dodaj pozycję</div>
				</div>
			</div>
		</div>
	</div>
</div>
